const conditionIndicatorsList = {
  bindings: {
    asset: '<',
    ciType: '<',
    subsystem: '<',
    chartVisible: '<',
    onDisplayGraph: '&',
    onDisplayConfig: '&',
  },
  templateUrl:
    '/modules/modals/subsystem-modal/condition-indicators-list/condition-indicators-list.html',
  controller: 'ConditionIndicatorsListController',
};

angular
  .module('modalDirectives')
  .component('conditionIndicatorsList', conditionIndicatorsList);
